import React, { useContext } from 'react';

import classnames from 'classnames';

import Colors from 'common/colors/constants';
import Truncate from 'common/common/Truncate';
import { CompanyContext } from 'common/containers/CompanyContainer';
import { ParamsContext } from 'common/containers/RouterContainer';
import { DefaultTintColor, TintColorContext } from 'common/containers/TintColorContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import useViewTracking from 'common/hooks/useViewTracking';
import translateString from 'common/i18n/translateString';
import Link from 'common/Link';
import plaintext from 'common/markdown/plaintext';
import nbspLastSpace from 'common/util/nbspLastSpace';

import type { Company } from 'common/api/endpoints/companies';
import type { Entry } from 'common/api/endpoints/entries';

import 'css/components/changelog/widget/_ChangelogWidgetEntryListItem.scss';

type Props = {
  entry: Entry;
  unread: boolean;
};

const ChangelogWidgetEntryListItem = ({ entry, unread }: Props) => {
  const viewer = useContext(ViewerContext);
  const params = useContext(ParamsContext);
  const company = useContext<Company>(CompanyContext);
  const tintColor = useContext(TintColorContext);
  const entryURL = `/${company._id}/${entry.urlName}`;
  const style = {
    borderLeftColor: unread ? (tintColor ?? DefaultTintColor) : Colors.white,
    borderLeftStyle: 'solid',
    borderLeftWidth: unread ? '2px' : '0',
    paddingLeft: unread ? '18px' : '20px',
  } as const;
  const preview = plaintext(translateString(entry, 'details'));
  const viewRef = useViewTracking(viewer, 'changelog', entry._id, company, true);

  return (
    <Link className="changelogWidgetEntryListItem" style={style} to={entryURL}>
      <div ref={params.entryURLName ? null : viewRef} className="heading">
        <Truncate numberOfLines={2}>
          {entry.types.map((type) => {
            const className = classnames('type', `${type.toLowerCase()}Type`);
            return (
              <span className={className} key={type}>
                {type}
              </span>
            );
          })}
          <span className="title" key="title">
            {nbspLastSpace(translateString(entry, 'title'))}
          </span>
        </Truncate>
      </div>
      <div className="details">
        <Truncate numberOfLines={2}>{preview}</Truncate>
      </div>
    </Link>
  );
};

export default ChangelogWidgetEntryListItem;
